import React from "react";
import "./techniques.css";

class Techniques extends React.Component {

    render() {

        return(
            <div className="techniquesContainer">
                <div className="headline" id="verticalInflate">
                        How marquetry is done
                </div>
                <div className="titleCaption"  data-aos="fade" data-aos-duration="2000">
                    First, the concept for the marquetry artwork is decided on.
                    <br></br>
                    This is usually based on a photograph.
                </div>
                <div className="techniqueImageBox" data-aos="fade" data-aos-duration="2000">
                    <img src="./images/palm.jpg" className="techniqueImage" alt="A shot of a palm fromme that I took in Florida." />
                </div>
                <div className="techniquesContent" data-aos="fade-up">
                    The next step is to create a line drawing based on the picture concept. During this process, elements can be added or removed to make the composition more interesting.
                </div>
                <div className="techniquesContent" data-aos="fade-up">
                    Before any cutting can take place, there is a lot of planning that needs to be done. Hours are spent picking which woods will be used to represent each individual piece in the artwork. Subtle tonal differences need to be achieved for areas where lighting in the picture varies.
                </div>
                <div className="techniquesContent" data-aos="fade-up">
                    Each individual piece is then cut out by hand and the pieces are fit together to form the complete image.
                </div>
                <div className="techniqueImageBox" data-aos="fade" data-aos-duration="3000">
                    <img src="./images/palmProgress.jpg" className="techniqueImage" id="doubleImage" alt="Progress shown on cutting each piece of the whole." />
                </div>
                <div className="techniquesContent" data-aos="fade-up">
                    Once all of the pieces are cut and assembled, a backing board is covered in wood glue and the artwork assembly is bonded together. A press is used to ensure good a good, strong bond.
                </div>
                <div className="techniqueImageBox" data-aos="fade" data-aos-duration="3000">
                    <img src="./images/press.jpg" className="techniqueImage" alt="An old, turn wheel press used to complete the bonding process." />
                </div>
                <div className="techniquesContent" data-aos="fade-up">
                    The surface of the bonded artwork is then scraped by hand with a cabinet scraper to level the surface and remove any glue squeeze.
                </div>
                <div className="techniqueImageBox" data-aos="fade" data-aos-duration="3000">
                    <img src="./images/misc/handWork2.jpg" className="techniqueImage" alt="The hand scraping proces." />
                </div>
                <div className="techniquesContent" data-aos="fade-up">
                    The surface is then sanded from course to fine until it is perfectly level and smooth.
                </div>
                <div className="techniquesContent" data-aos="fade-up">
                    Next, a coat of sanding sealer (shellac) is applied. This soaks into the woodgrain and gives a good base for later coats of finish. The surface is sanded again with 220 grit and the finish coats are then applied. The final coats are usually lacquer, but can also be polyurethane or 2-part clear epoxy.
                </div>
                <br></br>
                <div className="titleCaption" data-aos="fade-up">
                    The finished work of art:
                </div>
                <br></br>
                <div className="techniqueImageBox" data-aos="fade" data-aos-duration="3000">
                    <img src="./images/Palm1.jpg" className="techniqueImage" alt="The completed marquetry artwork." />
                </div>
                <br></br>
                <div className="sideBySideContainer">
                    <div className="linkBox">
                        <a href="./images/misc/classicyachtnovdec2011edit.pdf">
                            <figcaption className="caption">Read an article about my work. (I made the cover photo)</figcaption>
                            <img src="./images/misc/classicYachtLogo2.jpg" className="twoLogos" alt="This will take you to an issue of Classic Yacht Magazine where there is an article about my artwork." />
                        </a>
                    </div>
                    <br></br><br></br>
                    <div className="linkBox">
                        <a href="https://www.woodyboater.com/blog/2011/07/26/the-teeny-tiny-world-and-the-enormous-artistry-of-charles-bingham/">
                            <figcaption className="caption">Read about a client's experience having a custom piece of art created.</figcaption>
                            <img src="./images/misc/woodyBoaterLogo2.jpg" className="twoLogos" alt="This will take you to an article written by a client about his experience commissioning a custom piece of marquetry artwork." />
                        </a>
                    </div>
                </div>
                <br></br>
            </div>
        );
    }
};

export default Techniques;